import React, { forwardRef, useId } from 'react';
import { cn } from '../../lib/utils';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  label,
  error,
  id,
  ...props
}, ref) => {
  const inputId = id || useId();
  return <div className="w-full space-y-2" data-id="element-129">
        {label && <label htmlFor={inputId} className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-gray-700" data-id="element-130">
            {label}
          </label>}
        <input type={type} id={inputId} className={cn('flex h-11 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50', error && 'border-red-500 focus-visible:ring-red-500', className)} ref={ref} {...props} data-id="element-131" />
        {error && <p className="text-sm text-red-500" data-id="element-132">{error}</p>}
      </div>;
});
Input.displayName = 'Input';
export { Input };